import { PropsWithChildren } from 'react';

export const Columns: React.FC<PropsWithChildren> & {
  FlexGrow: React.FC<PropsWithChildren>;
  Flex35: React.FC<PropsWithChildren>;
} = ({ children }) => <div className="flex w-full h-full overflow-hidden">{children}</div>;
Columns.FlexGrow = ({ children }) => <div className="flex-1 overflow-hidden">{children}</div>;
Columns.FlexGrow.displayName = 'Columns.FlexGrow';
Columns.Flex35 = ({ children }) => <div className="w-[35%] overflow-y-auto">{children}</div>;
Columns.Flex35.displayName = 'Columns.Flex35';
